<cap-content-header [disableBreadcrumb]="true">
  <cap-title>
    {{ "core.navigation.erweitertesSuchregister" | translate }}
  </cap-title>
</cap-content-header>
<form #form="ngForm">
  <div class="col-12 my-2">
    <div class="row d-inline-flex">
      <div class="col">
        <button (click)="exportEigentuemer()" [disabled]="isLoading" class="btn btn-primary btn-actionpane" type="submit">
          {{ "Export" | translate }}
          @if (isLoading) {
            <span class="mt-2">
              <i class="fas fa-spinner fa-lg fa-fw fa-spin spinner" id="grundstueckSpinnerIcon"></i>
              <span class="sr-only">Loading...</span>
            </span>
          }
        </button>
      </div>
      <div class="col">
        <cap-form-control labelKey="erweitertesSuchregister.MitGebaeude" style="min-width: max-content">
          <input [(ngModel)]="mitGebaeude" name="mitGebaeude" type="checkbox" />
        </cap-form-control>
      </div>
    </div>
    <div class="row">
      <p class="mt-2"><i class="fas fa-info-circle"></i> {{ "erweitertesSuchregister.infoMessage" | translate }}</p>
    </div>
  </div>
</form>
